import styled from 'styled-components';

import { ACQ, ANIM, COLORS, MOBILE, SPACE } from '../../../../theme/tokens';

/* The Website section's tab row (Website Creatives · Logos · Art Style · Game Lists · Blog). Pill-row tabs matching
   the Acquisition/Operations page-level browser tabs: no underline strip, the row hugs the tabs, and the active
   tab carries a fill PLUS a hairline border, so it stays legible on the light theme where a quiet fill alone
   vanishes on the white card. On a phone the row scrolls sideways instead of squeezing the labels. */
export const TabsBar = styled.div`
  display: flex;
  align-items: center;
  gap: ${SPACE[4]};
  height: 48px;
  margin: 0 0 ${SPACE[20]};

  ${MOBILE} {
    margin-bottom: ${SPACE[16]};
    overflow-x: auto;
    scrollbar-width: none;

    &::-webkit-scrollbar {
      display: none;
    }
  }
`;

/* One section tab. Dark keeps the 8% white lift with a transparent border; light swaps in a deeper grey
   fill and a visible hairline, using the same ACQ page-level tokens as the campaign browsers so the rows
   stay in lockstep across themes. (A page-local button rather than the shared Tab component, which paints
   only the low contrast fill and has no active border.) */
export const MainTab = styled.button<{ $active: boolean }>`
  display: inline-flex;
  align-items: center;
  gap: ${SPACE[8]};
  height: 48px;
  /* 14px, off the scale: the row's width as it shipped before the hub, kept so the restored row is unchanged. */
  padding: 0 14px;
  box-sizing: border-box;
  border-radius: 12px;
  cursor: pointer;
  font-size: 15px;
  white-space: nowrap;
  background: ${({ $active }) => ($active ? ACQ.tabPageActiveBg : 'transparent')};
  border: 1px solid ${({ $active }) => ($active ? ACQ.tabPageActiveBorder : 'transparent')};
  color: ${({ $active }) => ($active ? COLORS.text : COLORS.textMuted)};
  transition:
    background ${ANIM.INTERACT_MS}ms ease,
    color ${ANIM.INTERACT_MS}ms ease,
    border-color ${ANIM.INTERACT_MS}ms ease;

  ${MOBILE} {
    /* Grow to share the row, never shrink: a label that doesn't fit scrolls the row instead of wrapping. */
    flex: 1 0 auto;
    justify-content: center;
    padding: 0 ${SPACE[12]};
    font-size: 14px;
  }
`;
